import React, { useEffect, useState, useRef } from 'react';
import './Obsequios.css';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Download, Gift, Truck, } from "lucide-react";
import { FiGift, FiSearch, FiEye, FiEdit2, FiSend, FiUsers, FiTrash2, FiUpload, FiRefreshCw, FiUserCheck, FiCalendar, FiCheckCircle, FiTruck } from "react-icons/fi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import PageTitle from "../components/PageTitle";

const API = process.env.REACT_APP_API_URL;

function Obsequios() {
  const [asociados, setAsociados] = useState([]);
  const [filteredAsociados, setFilteredAsociados] = useState([]);
  const [filtros, setFiltros] = useState({
    ciudad: '',
    empresa: '',
    obsequio: '',
    estado: '',
    busqueda: '',
    ejecutivo: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(25);
  const [showModal, setShowModal] = useState(false);
  const [entregasHabilitadas, setEntregasHabilitadas] = useState(true);
  const [mostrarTodasZonas, setMostrarTodasZonas] = useState(false);

  const [nuevoRegistro, setNuevoRegistro] =
    useState({
      Cedula: "",
      Nombre: "",
      Telefono: "",
      Ciudad: "",
      Empresa: "",
      Obsequio: ""
    });

  // === Cargar datos ===
  useEffect(() => {
    axios.get(`${API}/api/obsequios/listar`)
      .then(response => {
        setAsociados(response.data);
        setFilteredAsociados(
          response.data.sort((a, b) => Number(a.Cedula) - Number(b.Cedula))
        );
      })
      .catch(error => {
        console.error('Error al cargar los asociados:', error);
      });
  }, []);

  useEffect(() => {
    const cargarConfig = async () => {
      try {
        const res = await axios.get(`${API}/api/obsequios/config-entregas`);
        setEntregasHabilitadas(res.data.entregasHabilitadas);
      } catch (err) {
        console.log("Error cargando config");
      }
    };

    cargarConfig();
  }, []);

  // ============================
  // ⭐ RESUMEN SUPERIOR
  // ============================
  const resumenGeneral = (lista) => {
    const registros = Array.isArray(lista) ? lista : [];

    const total = registros.length;

    const entregadosLista = registros.filter(
      (a) => a.Estado_Entrega === "Entregado"
    );

    const pendientesLista = registros.filter(
      (a) => a.Estado_Entrega !== "Entregado"
    );

    const entregados = entregadosLista.length;
    const pendientes = pendientesLista.length;

    const porcentaje =
      total > 0
        ? Math.round((entregados / total) * 100)
        : 0;

    /* =========================
       ENTREGADOS HOY
    ========================= */

    const hoy = new Date();

    const entregadosHoy = entregadosLista.filter((a) => {
      if (!a.fechaEntrega) return false;

      const fecha = new Date(a.fechaEntrega);

      return (
        fecha.getFullYear() === hoy.getFullYear() &&
        fecha.getMonth() === hoy.getMonth() &&
        fecha.getDate() === hoy.getDate()
      );
    }).length;

    /* =========================
       TIPOS DE OBSEQUIO
    ========================= */

    const tipos = {};

    registros.forEach((a) => {
      const tipo = String(
        a.Obsequio || "Sin especificar"
      ).trim();

      if (!tipos[tipo]) {
        tipos[tipo] = {
          total: 0,
          entregados: 0,
          pendientes: 0,
          porcentaje: 0,
        };
      }

      tipos[tipo].total++;

      if (a.Estado_Entrega === "Entregado") {
        tipos[tipo].entregados++;
      } else {
        tipos[tipo].pendientes++;
      }
    });

    Object.keys(tipos).forEach((tipo) => {
      tipos[tipo].porcentaje =
        tipos[tipo].total > 0
          ? Math.round(
            (tipos[tipo].entregados /
              tipos[tipo].total) *
            100
          )
          : 0;
    });

    /* =========================
       MÉTODOS DE ENTREGA
    ========================= */

    const metodos = {
      WhatsApp: 0,
      Interna: 0,
      SinRegistrar: 0,
    };

    entregadosLista.forEach((a) => {
      const metodo = String(
        a.metodoEntrega || ""
      ).trim();

      if (metodo === "WhatsApp") {
        metodos.WhatsApp++;
      } else if (metodo === "Interna") {
        metodos.Interna++;
      } else {
        metodos.SinRegistrar++;
      }
    });

    /* =========================
       ZONAS
    ========================= */

    const zonas = {};

    registros.forEach((a) => {
      const zona = String(
        a.Ciudad || "Sin especificar"
      ).trim();

      if (!zonas[zona]) {
        zonas[zona] = {
          total: 0,
          entregados: 0,
        };
      }

      zonas[zona].total++;

      if (a.Estado_Entrega === "Entregado") {
        zonas[zona].entregados++;
      }
    });

    const zonasOrdenadas = Object.entries(zonas)
      .map(([nombre, datos]) => ({
        nombre,
        ...datos,
        porcentaje:
          datos.total > 0
            ? Math.round(
              (datos.entregados / datos.total) * 100
            )
            : 0,
      }))
      .sort((a, b) => {
        // 1. Primero: mayor cantidad de entregados
        if (b.entregados !== a.entregados) {
          return b.entregados - a.entregados;
        }

        // 2. Si tienen la misma cantidad de entregados:
        // mayor cantidad de asignados
        if (b.total !== a.total) {
          return b.total - a.total;
        }

        // 3. Si también empatan: orden alfabético
        return a.nombre.localeCompare(b.nombre, "es", {
          sensitivity: "base",
        });
      });

    /* =========================
       ÚLTIMAS ENTREGAS
    ========================= */

    const ultimasEntregas = entregadosLista
      .filter((a) => a.fechaEntrega)
      .sort(
        (a, b) =>
          new Date(b.fechaEntrega) -
          new Date(a.fechaEntrega)
      );

    return {
      total,
      entregados,
      pendientes,
      porcentaje,
      entregadosHoy,
      tipos,
      metodos,
      zonas: zonasOrdenadas,
      ultimasEntregas,
    };
  };

  // ============================
  // FILTROS DINÁMICOS
  // ============================

  const FILTROS_INICIALES = {
    ciudad: "",
    empresa: "",
    obsequio: "",
    estado: "",
    busqueda: "",
    ejecutivo: "",
  };

  const coincideBusqueda = (asociado, busqueda) => {
    const texto = String(busqueda || "")
      .trim()
      .toLowerCase();

    if (!texto) {
      return true;
    }

    const cedula = String(asociado.Cedula || "")
      .trim()
      .toLowerCase();

    const nombre = String(asociado.Nombre || "")
      .trim()
      .toLowerCase();

    return cedula.includes(texto) || nombre.includes(texto);
  };

  const aplicarFiltros = (
    lista,
    filtrosAplicados,
    filtroIgnorado = null
  ) => {
    return lista.filter((asociado) => {
      if (
        filtroIgnorado !== "busqueda" &&
        !coincideBusqueda(
          asociado,
          filtrosAplicados.busqueda
        )
      ) {
        return false;
      }

      if (
        filtroIgnorado !== "ciudad" &&
        filtrosAplicados.ciudad &&
        String(asociado.Ciudad || "").trim() !==
        filtrosAplicados.ciudad
      ) {
        return false;
      }

      if (
        filtroIgnorado !== "empresa" &&
        filtrosAplicados.empresa &&
        String(asociado.Empresa || "").trim() !==
        filtrosAplicados.empresa
      ) {
        return false;
      }

      if (
        filtroIgnorado !== "obsequio" &&
        filtrosAplicados.obsequio &&
        String(asociado.Obsequio || "").trim() !==
        filtrosAplicados.obsequio
      ) {
        return false;
      }

      if (
        filtroIgnorado !== "estado" &&
        filtrosAplicados.estado &&
        String(asociado.Estado_Entrega || "").trim() !==
        filtrosAplicados.estado
      ) {
        return false;
      }

      if (
        filtroIgnorado !== "ejecutivo" &&
        filtrosAplicados.ejecutivo &&
        String(asociado.ejecutivo || "").trim() !==
        filtrosAplicados.ejecutivo
      ) {
        return false;
      }

      return true;
    });
  };

  const obtenerOpcionesFiltro = (
    campo,
    filtroIgnorado
  ) => {
    const registrosCompatibles = aplicarFiltros(
      asociados,
      filtros,
      filtroIgnorado
    );

    return [
      ...new Set(
        registrosCompatibles
          .map((registro) =>
            String(registro[campo] || "").trim()
          )
          .filter(Boolean)
      ),
    ].sort((a, b) =>
      a.localeCompare(b, "es", {
        sensitivity: "base",
        numeric: true,
      })
    );
  };

  const opcionesCiudad = obtenerOpcionesFiltro(
    "Ciudad",
    "ciudad"
  );

  const opcionesEmpresa = obtenerOpcionesFiltro(
    "Empresa",
    "empresa"
  );

  const opcionesObsequio = obtenerOpcionesFiltro(
    "Obsequio",
    "obsequio"
  );

  const opcionesEstado = obtenerOpcionesFiltro(
    "Estado_Entrega",
    "estado"
  );

  const opcionesEjecutivo = obtenerOpcionesFiltro(
    "ejecutivo",
    "ejecutivo"
  );

  const actualizarResultadosFiltrados = (
    filtrosNuevos
  ) => {
    const resultados = aplicarFiltros(
      asociados,
      filtrosNuevos
    );

    resultados.sort((a, b) => {
      const cedulaA = String(a.Cedula || "");
      const cedulaB = String(b.Cedula || "");

      return cedulaA.localeCompare(cedulaB, "es", {
        numeric: true,
      });
    });

    setFilteredAsociados(resultados);
    setCurrentPage(1);
  };

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;

    const nuevosFiltros = {
      ...filtros,
      [name]: value,
    };

    setFiltros(nuevosFiltros);
    actualizarResultadosFiltrados(nuevosFiltros);
  };

  const restablecerFiltros = () => {
    setFiltros(FILTROS_INICIALES);
    setMostrarTodasZonas(false);

    const registrosOrdenados = [...asociados].sort(
      (a, b) =>
        String(a.Cedula || "").localeCompare(
          String(b.Cedula || ""),
          "es",
          { numeric: true }
        )
    );

    setFilteredAsociados(registrosOrdenados);
    setCurrentPage(1);

    toast.info("Los filtros fueron restablecidos.");
  };

  const hayFiltrosActivos = Object.values(filtros).some(
    (valor) => String(valor || "").trim() !== ""
  );

  const resumen = resumenGeneral(
    hayFiltrosActivos
      ? filteredAsociados
      : asociados
  );

  const zonasResumen = Array.isArray(resumen?.zonas)
    ? resumen.zonas
    : [];

  const zonasVisibles = mostrarTodasZonas
    ? zonasResumen
    : zonasResumen.slice(0, 5);

  const hayMasZonas = zonasResumen.length > 5;

  // ============================
  // ⭐ PAGINACIÓN
  // ============================
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredAsociados.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPaginas = Math.ceil(filteredAsociados.length / recordsPerPage);

  // ============================
  // ⭐ EXPORTAR
  // ============================
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredAsociados);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Asociados');
    XLSX.writeFile(wb, 'reporte_obsequios.xlsx');
  };

  // ============================
  // ⭐ GUARDAR REGISTRO NUEVO
  // ============================
  const handleGuardar = async () => {
    const registro = {
      Cedula: String(
        nuevoRegistro.Cedula || ""
      ).trim(),

      Nombre: String(
        nuevoRegistro.Nombre || ""
      ).trim(),

      Telefono: String(
        nuevoRegistro.Telefono || ""
      ).trim(),

      Ciudad: String(
        nuevoRegistro.Ciudad || ""
      ).trim(),

      Empresa: String(
        nuevoRegistro.Empresa || ""
      ).trim(),

      Obsequio: String(
        nuevoRegistro.Obsequio || ""
      ).trim()
    };

    if (
      !registro.Cedula ||
      !registro.Nombre ||
      !registro.Telefono ||
      !registro.Obsequio
    ) {
      toast.warn(
        "Completa la cédula, el nombre, el teléfono y el obsequio."
      );

      return;
    }

    try {
      console.log(
        "📤 REGISTRO ENVIADO:",
        registro
      );

      const response =
        await axios.post(
          `${API}/api/obsequios/agregar`,
          registro
        );

      toast.success(
        response.data?.message ||
        "Registro agregado correctamente"
      );

      setShowModal(false);

      setNuevoRegistro({
        Cedula: "",
        Nombre: "",
        Telefono: "",
        Ciudad: "",
        Empresa: "",
        Obsequio: ""
      });

      const listado =
        await axios.get(
          `${API}/api/obsequios/listar`
        );

      setAsociados(
        listado.data
      );

      setFilteredAsociados(
        listado.data
      );
    } catch (error) {
      const respuesta =
        error.response?.data;

      console.error(
        "❌ ERROR DEL BACKEND:",
        respuesta || error
      );

      toast.error(
        respuesta?.message ||
        respuesta?.error ||
        "Error al guardar el registro"
      );
    }
  };

  const [entregaSeleccionada, setEntregaSeleccionada] = useState(null);
  const [editarAsociado, setEditarAsociado] = useState(null);
  const [asociadoParaEntregar, setAsociadoParaEntregar] = useState(null);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importRows, setImportRows] = useState([]);
  const [importLoading, setImportLoading] = useState(false);
  const fileImportRef = useRef(null);

  // ============================================
  // PROCESO DE ENTREGA DESDE EL MÓDULO INTERNO
  // ============================================

  const [modalEntrega, setModalEntrega] = useState(false);

  const [metodoEntregaSeleccionado, setMetodoEntregaSeleccionado] =
    useState("");

  const [ejecutivoSeleccionado, setEjecutivoSeleccionado] =
    useState(null);

  const [busquedaEjecutivoEntrega, setBusquedaEjecutivoEntrega] =
    useState("");

  const [codigoEntregaWhatsapp, setCodigoEntregaWhatsapp] =
    useState(null);

  const [codigoEntregaIngresado, setCodigoEntregaIngresado] =
    useState("");

  const [enviandoCodigoEntrega, setEnviandoCodigoEntrega] =
    useState(false);

  const [verificandoCodigoEntrega, setVerificandoCodigoEntrega] =
    useState(false);

  const [registrandoEntrega, setRegistrandoEntrega] =
    useState(false);

  const [timerEntrega, setTimerEntrega] = useState(0);

  const intervalEntregaRef = useRef(null);

  const guardarTelefonoEditado = async () => {
    try {
      await axios.put(
        `${API}/api/obsequios/actualizar-telefono/${editarAsociado.Cedula}`,
        { telefono: editarAsociado.Telefono } // 👈 ojo: telefono en minúscula
      );

      toast.success("Teléfono actualizado correctamente");

      setAsociados((prev) =>
        prev.map((a) =>
          a.Cedula === editarAsociado.Cedula
            ? { ...a, Telefono: editarAsociado.Telefono }
            : a
        )
      );

      setFilteredAsociados((prev) =>
        prev.map((a) =>
          a.Cedula === editarAsociado.Cedula
            ? { ...a, Telefono: editarAsociado.Telefono }
            : a
        )
      );

      setEditarAsociado(null);
    } catch (err) {
      console.error("❌ Error actualizando teléfono:", err.response?.data || err);
      toast.error(
        err.response?.data?.message ||
        "Error al actualizar teléfono (revisa la consola del navegador)."
      );
    }
  };

  const navigate = useNavigate();

  // ====== Gestion Ejecutivos ======
  const [showEjecutivosModal, setShowEjecutivosModal] = useState(false);
  const [ejecutivos, setEjecutivos] = useState([]);
  const [loadingEjecutivos, setLoadingEjecutivos] = useState(false);

  const [qEjecutivo, setQEjecutivo] = useState("");
  const [showCrearEjecutivo, setShowCrearEjecutivo] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState(null); // guarda el ejecutivo a borrar

  const [pageEjecutivos, setPageEjecutivos] = useState(1);
  const ejecutivosPerPage = 10

  const [nuevoEjecutivo, setNuevoEjecutivo] = useState({
    cedula: "",
    nombre: "",
    telefono: "",
    empresa: "",
    ciudad: "",
    estado: "activo",
  });

  const cargarEjecutivos = async () => {
    try {
      setLoadingEjecutivos(true);
      const res = await axios.get(`${API}/api/obsequios`);
      setEjecutivos(res.data || []);
    } catch (err) {
      console.error(err);
      toast.error("No se pudieron cargar los ejecutivos");
    } finally {
      setLoadingEjecutivos(false);
    }
  };

  const ejecutivosDisponibles = ejecutivos
    .filter((e) => {
      return (
        String(e.estado || "activo")
          .trim()
          .toLowerCase() === "activo"
      );
    })
    .filter((e) => {
      const busqueda = String(
        busquedaEjecutivoEntrega || ""
      )
        .trim()
        .toLowerCase();

      if (!busqueda) {
        return true;
      }

      const nombre = String(
        e.nombre || ""
      ).toLowerCase();

      const cedula = String(
        e.cedula || ""
      ).toLowerCase();

      const empresa = String(
        e.empresa || ""
      ).toLowerCase();

      return (
        nombre.includes(busqueda) ||
        cedula.includes(busqueda) ||
        empresa.includes(busqueda)
      );
    })
    .sort((a, b) =>
      String(a.nombre || "").localeCompare(
        String(b.nombre || ""),
        "es",
        {
          sensitivity: "base",
        }
      )
    );

  const abrirModalEntrega = async (asociado) => {
    if (asociado.Estado_Entrega === "Entregado") {
      return;
    }

    setAsociadoParaEntregar(asociado);

    setMetodoEntregaSeleccionado("");
    setEjecutivoSeleccionado(null);
    setBusquedaEjecutivoEntrega("");

    setCodigoEntregaWhatsapp(null);
    setCodigoEntregaIngresado("");

    setEnviandoCodigoEntrega(false);
    setVerificandoCodigoEntrega(false);
    setRegistrandoEntrega(false);

    setTimerEntrega(0);

    if (intervalEntregaRef.current) {
      clearInterval(intervalEntregaRef.current);
      intervalEntregaRef.current = null;
    }

    await cargarEjecutivos();

    setModalEntrega(true);
  };

  const cerrarModalEntrega = () => {
    if (intervalEntregaRef.current) {
      clearInterval(intervalEntregaRef.current);
      intervalEntregaRef.current = null;
    }

    setModalEntrega(false);

    setAsociadoParaEntregar(null);
    setMetodoEntregaSeleccionado("");
    setEjecutivoSeleccionado(null);
    setBusquedaEjecutivoEntrega("");

    setCodigoEntregaWhatsapp(null);
    setCodigoEntregaIngresado("");

    setEnviandoCodigoEntrega(false);
    setVerificandoCodigoEntrega(false);
    setRegistrandoEntrega(false);

    setTimerEntrega(0);
  };

  const registrarEntrega = async ({
    codigo = "",
    metodo,
    observacion,
  }) => {
    if (!asociadoParaEntregar) {
      toast.error(
        "No se encontró el asociado seleccionado."
      );
      return false;
    }

    if (!ejecutivoSeleccionado) {
      toast.warn(
        "Selecciona el responsable de la entrega."
      );
      return false;
    }

    const cedulaAsociado = String(
      asociadoParaEntregar.Cedula ||
      asociadoParaEntregar.cedula ||
      ""
    ).trim();

    const obsequioAsociado = String(
      asociadoParaEntregar.Obsequio ||
      asociadoParaEntregar.obsequio ||
      ""
    ).trim();

    const cedulaEjecutivo = String(
      ejecutivoSeleccionado.cedula || ""
    ).trim();

    if (!cedulaAsociado || !obsequioAsociado) {
      toast.error(
        "El registro seleccionado no tiene la información necesaria."
      );
      return false;
    }

    try {
      setRegistrandoEntrega(true);

      const respEntrega = await axios.post(
        `${API}/api/obsequios/marcar-entregado`,
        {
          cedula: cedulaAsociado,
          ejecutivo: cedulaEjecutivo,
          obsequio: obsequioAsociado,
          codigoEntrega: codigo,
          metodoEntrega: metodo,
          observacionEntrega: observacion,
        }
      );

      const entregaActualizada =
        respEntrega.data?.entrega;

      const fechaActual =
        entregaActualizada?.fechaEntrega ||
        new Date().toISOString();

      const actualizarAsociado = (asociado) => {
        const cedulaRegistro = String(
          asociado.Cedula ||
          asociado.cedula ||
          ""
        ).trim();

        const obsequioRegistro = String(
          asociado.Obsequio ||
          asociado.obsequio ||
          ""
        ).trim();

        const esMismoRegistro =
          cedulaRegistro === cedulaAsociado &&
          obsequioRegistro === obsequioAsociado;

        if (!esMismoRegistro) {
          return asociado;
        }

        return {
          ...asociado,

          Estado_Entrega: "Entregado",

          ejecutivo:
            entregaActualizada?.ejecutivo ||
            ejecutivoSeleccionado.nombre,

          cedulaEjecutivo:
            entregaActualizada?.cedulaEjecutivo ||
            cedulaEjecutivo,

          fechaEntrega:
            entregaActualizada?.fechaEntrega ||
            fechaActual,

          metodoEntrega:
            entregaActualizada?.metodoEntrega ||
            metodo,

          codigoEntrega:
            entregaActualizada?.codigoEntrega ||
            codigo,

          observacionEntrega:
            entregaActualizada?.observacionEntrega ||
            observacion,
        };
      };

      setAsociados((prev) =>
        prev.map(actualizarAsociado)
      );

      setFilteredAsociados((prev) =>
        prev.map(actualizarAsociado)
      );

      toast.success(
        respEntrega.data?.message ||
        "Entrega confirmada correctamente."
      );

      cerrarModalEntrega();

      return true;

    } catch (error) {
      console.error(
        "ERROR REGISTRANDO ENTREGA:",
        error.response?.data || error
      );

      toast.error(
        error.response?.data?.message ||
        "No fue posible registrar la entrega."
      );

      return false;

    } finally {
      setRegistrandoEntrega(false);
    }
  };

  const confirmarEntregaInterna = async () => {
    if (!ejecutivoSeleccionado) {
      toast.warn(
        "Selecciona el responsable de la entrega."
      );
      return;
    }

    await registrarEntrega({
      codigo: "",
      metodo: "Interna",
      observacion:
        "Entrega registrada directamente desde el módulo administrativo de obsequios.",
    });
  };

  const enviarCodigoEntregaWhatsapp = async () => {
    if (!asociadoParaEntregar) {
      return;
    }

    if (!ejecutivoSeleccionado) {
      toast.warn(
        "Selecciona primero el responsable de la entrega."
      );
      return;
    }

    if (timerEntrega > 0) {
      return;
    }

    try {
      setEnviandoCodigoEntrega(true);

      toast.info(
        "Enviando código por WhatsApp..."
      );

      const response = await axios.post(
        `${API}/api/obsequios/enviar-codigo-whatsapp`,
        {
          asociado:
            asociadoParaEntregar.Cedula,

          ejecutivo:
            ejecutivoSeleccionado.cedula,

          obsequio:
            asociadoParaEntregar.Obsequio,
        }
      );

      setCodigoEntregaWhatsapp(
        String(response.data.codigo)
      );

      setCodigoEntregaIngresado("");

      toast.success(
        response.data?.message ||
        "Código enviado correctamente."
      );

      setTimerEntrega(60);

      if (intervalEntregaRef.current) {
        clearInterval(intervalEntregaRef.current);
      }

      intervalEntregaRef.current =
        setInterval(() => {
          setTimerEntrega((prev) => {
            if (prev <= 1) {
              clearInterval(
                intervalEntregaRef.current
              );

              intervalEntregaRef.current = null;

              return 0;
            }

            return prev - 1;
          });
        }, 1000);

    } catch (error) {
      console.error(
        "ERROR ENVIANDO REFERENCIA:",
        error.response?.data || error
      );

      toast.error(
        error.response?.data?.message ||
        "No fue posible enviar el código por WhatsApp."
      );

    } finally {
      setEnviandoCodigoEntrega(false);
    }
  };

  const verificarCodigoEntregaWhatsapp = async (
    codigoAValidar = codigoEntregaIngresado
  ) => {
    if (verificandoCodigoEntrega) {
      return;
    }

    const codigo = String(
      codigoAValidar || ""
    ).trim();

    if (codigo.length !== 6) {
      toast.warn(
        "Ingrese los seis dígitos del código."
      );
      return;
    }

    if (
      codigo !==
      String(codigoEntregaWhatsapp || "")
    ) {
      toast.error(
        "El código ingresado no es correcto."
      );

      return;
    }

    try {
      setVerificandoCodigoEntrega(true);

      await registrarEntrega({
        codigo,
        metodo: "WhatsApp",
        observacion:
          "Entrega confirmada mediante código enviado por WhatsApp.",
      });

    } finally {
      setVerificandoCodigoEntrega(false);
    }
  };

  const abrirGestionEjecutivos = async () => {
    setShowEjecutivosModal(true);
    await cargarEjecutivos();
  };

  const crearEjecutivo = async () => {
    if (!nuevoEjecutivo.cedula.trim() || !nuevoEjecutivo.nombre.trim()) {
      return toast.warn("Cédula y nombre son obligatorios.");
    }

    try {
      await axios.post(`${API}/api/obsequios`, nuevoEjecutivo, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Ejecutivo autorizado");
      setNuevoEjecutivo({
        cedula: "",
        nombre: "",
        telefono: "",
        empresa: "",
        ciudad: "",
        estado: "activo",
      });

      await cargarEjecutivos();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Error creando ejecutivo");
    }
  };

  const eliminarEjecutivo = async (id) => {
    const ok = window.confirm("¿Seguro deseas eliminar este ejecutivo?");
    if (!ok) return;

    try {
      await axios.delete(`${API}/api/obsequios/${id}`);
      toast.info("Ejecutivo eliminado");
      await cargarEjecutivos();
    } catch (err) {
      console.error(err);
      toast.error("Error eliminando ejecutivo");
    }
  };

  const ejecutivosFiltrados = ejecutivos.filter((e) => {
    const q = qEjecutivo.trim().toLowerCase();
    if (!q) return true;

    return (
      (e.cedula || "").toLowerCase().includes(q) ||
      (e.nombre || "").toLowerCase().includes(q) ||
      (e.empresa || "").toLowerCase().includes(q) ||
      (e.ciudad || "").toLowerCase().includes(q) ||
      (e.telefono || "").toLowerCase().includes(q)
    );
  });

  // si cambia búsqueda o lista, vuelve a página 1
  useEffect(() => {
    setPageEjecutivos(1);
  }, [qEjecutivo, ejecutivos.length]);

  const totalPagesEjecutivos = Math.max(
    1,
    Math.ceil(ejecutivosFiltrados.length / ejecutivosPerPage)
  );

  const startEj = (pageEjecutivos - 1) * ejecutivosPerPage;
  const endEj = startEj + ejecutivosPerPage;
  const ejecutivosPageItems = ejecutivosFiltrados.slice(startEj, endEj);

  const handleImportFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });

        if (!jsonData || jsonData.length === 0) {
          toast.warn("El archivo está vacío o mal estructurado.");
          return;
        }

        setImportRows(jsonData);
        setShowImportModal(true);
      } catch (err) {
        console.error("❌ Error leyendo archivo:", err);
        toast.error("Error al leer el archivo.");
      }
    };

    reader.readAsArrayBuffer(file);

    // ✅ permite volver a seleccionar el mismo archivo
    e.target.value = "";
  };

  const confirmarImportacionObsequios = async () => {
    if (importRows.length === 0) return;

    try {
      setImportLoading(true);

      const resp = await axios.post(
        `${API}/api/obsequios/importar`,
        { rows: importRows },
        { headers: { "Content-Type": "application/json" } }
      );

      toast.success(
        `✅ Importación lista: ${resp.data.inserted} insertados / ${resp.data.skipped} omitidos`
      );

      // ✅ recargar listado
      const response = await axios.get(`${API}/api/obsequios/listar`);
      setAsociados(response.data);
      setFilteredAsociados(
        response.data.sort((a, b) => Number(a.Cedula) - Number(b.Cedula))
      );

      cerrarImportModalObsequios();
    } catch (err) {
      console.error("❌ Error importando:", err);
      toast.error(err.response?.data?.message || "Error importando base.");
    } finally {
      setImportLoading(false);
    }
  };

  const cerrarImportModalObsequios = () => {
    setShowImportModal(false);
    setImportRows([]);
    setImportLoading(false);
  };

  const toggleEntregas = async () => {
    try {
      const nuevoEstado = !entregasHabilitadas;

      await axios.put(`${API}/api/obsequios/config-entregas`, {
        estado: nuevoEstado
      });

      setEntregasHabilitadas(nuevoEstado);

    } catch (error) {
      console.log("Error cambiando estado");
    }
  };

  return (

    <>

      <PageTitle title="Obsequios" />

      <div className="obq-root">

        {/* ===== HEADER ===== */}
        <header className="obq-header">
          <h2 className="inv-title">
            | Obsequios
          </h2>
          <div className="inv-actions">
            <button
              className={`toggle-entregas ${entregasHabilitadas ? "activo" : "inactivo"}`}
              onClick={toggleEntregas}
            >
              <span className="estado-dot"></span>
              {entregasHabilitadas ? "Entregas activas" : "Entregas deshabilitadas"}
            </button>

            <button
              className="obs-btn-secondary inv-btn-excel"
              onClick={exportToExcel}>
              <Download size={15} /> Exportar Excel
            </button>

            <button
              className="inv-btn-primary inv-btn-excel"
              onClick={() => fileImportRef.current?.click()}
            >
              <FiUpload size={15} /> Importar base
            </button>

            <input
              ref={fileImportRef}
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={handleImportFile}
              hidden
            />

            <button
              className="inv-btn-primary"
              onClick={() => setShowModal(true)}>
              <Gift size={15} /> Crear entrega
            </button>

            <button className="inv-btn-primary" onClick={abrirGestionEjecutivos}>
              <FiUsers size={15} /> Gestionar ejecutivos
            </button>

            <button
              className="inv-btn-primary"
              onClick={() => window.open("/ejecutivo-obsequios", "_blank")}
            >
              <FiSend size={15} /> Entregas360
            </button>
          </div>
        </header>

        {/* ======================================
       ⭐ RESUMEN SUPERIOR (estilo inventario)
        ====================================== */}
        <div className="obq-dashboard">

          {/* =====================================
      AVANCE GENERAL
  ====================================== */}

          <div className="obq-dashboard-progress">

            <div className="obq-progress-header">

              <div>
                <h3>
                  Avance general
                </h3>

                <span>
                  {hayFiltrosActivos
                    ? "Resultados según los filtros aplicados"
                    : "Consolidado general de obsequios"}
                </span>
              </div>

              <div className="obq-progress-number">
                {resumen.porcentaje}%
              </div>

            </div>

            <div className="obq-progress-track">
              <div
                className="obq-progress-fill"
                style={{
                  width: `${resumen.porcentaje}%`
                }}
              />
            </div>

            <div className="obq-progress-stats">

              <span>
                Asignados: {" "}
                <strong>
                  {resumen.total.toLocaleString("es-CO")}
                </strong>
              </span>

              <span>
                Entregados: {" "}
                <strong>
                  {resumen.entregados.toLocaleString("es-CO")}
                </strong>
              </span>

              <span>
                Pendientes: {" "}
                <strong>
                  {resumen.pendientes.toLocaleString("es-CO")}
                </strong>
              </span>


            </div>

          </div>


          {/* =====================================
      KPI
  ====================================== */}

          <div className="obq-kpis">

            <div className="obq-kpi-card">

              <div className="obq-kpi-icon purple">
                <FiGift size={19} />
              </div>

              <div>
                <span>Obsequios asignados</span>

                <strong>
                  {resumen.total.toLocaleString("es-CO")}
                </strong>
              </div>

            </div>


            <div className="obq-kpi-card">

              <div className="obq-kpi-icon green">
                <FiUserCheck size={19} />
              </div>

              <div>
                <span>Entregados</span>

                <strong>
                  {resumen.entregados.toLocaleString("es-CO")}
                </strong>
              </div>

            </div>


            <div className="obq-kpi-card">

              <div className="obq-kpi-icon gray">
                <FiCalendar size={19} />
              </div>

              <div>
                <span>Pendientes</span>

                <strong>
                  {resumen.pendientes.toLocaleString("es-CO")}
                </strong>
              </div>

            </div>


            <div className="obq-kpi-card">

              <div className="obq-kpi-icon blue">
                <Truck size={19} />
              </div>

              <div>
                <span>Entregados hoy</span>

                <strong>
                  {resumen.entregadosHoy.toLocaleString("es-CO")}
                </strong>
              </div>

            </div>

          </div>


          {/* =====================================
      SEGUNDA FILA
  ====================================== */}

          <div className="obq-dashboard-grid">

            {/* AVANCE POR OBSEQUIO */}

            <div className="obq-dashboard-panel">

              <div className="obq-panel-header">
                <div>
                  <h3>Avance por obsequio</h3>
                  <span>
                    Entregados frente al total asignado
                  </span>
                </div>
              </div>

              <div className="obq-gift-progress-list">

                {Object.entries(resumen.tipos).map(
                  ([tipo, datos]) => (

                    <div
                      className="obq-gift-progress-item"
                      key={tipo}
                    >

                      <div className="obq-gift-progress-info">

                        <strong>{tipo}</strong>

                        <span>
                          {datos.entregados.toLocaleString("es-CO")}
                          {" de "}
                          {datos.total.toLocaleString("es-CO")}
                        </span>

                      </div>

                      <div className="obq-mini-progress-row">

                        <div className="obq-mini-progress">
                          <div
                            style={{
                              width: `${datos.porcentaje}%`
                            }}
                          />
                        </div>

                        <strong>
                          {datos.porcentaje}%
                        </strong>

                      </div>

                    </div>

                  )
                )}

              </div>

            </div>


            {/* MÉTODO DE ENTREGA */}

            <div className="obq-dashboard-panel">

              <div className="obq-panel-header">
                <div>
                  <h3>Método de entrega</h3>

                  <span>
                    Cómo fueron confirmadas las entregas
                  </span>
                </div>
              </div>

              <div className="obq-method-list">

                <div className="obq-method-row">

                  <div className="obq-method-label">
                    <span className="obq-method-dot whatsapp" />
                    WhatsApp
                  </div>

                  <strong>
                    {resumen.metodos.WhatsApp.toLocaleString(
                      "es-CO"
                    )}
                  </strong>

                </div>


                <div className="obq-method-row">

                  <div className="obq-method-label">
                    <span className="obq-method-dot interna" />
                    Entrega Interna
                  </div>

                  <strong>
                    {resumen.metodos.Interna.toLocaleString(
                      "es-CO"
                    )}
                  </strong>

                </div>


                {resumen.metodos.SinRegistrar > 0 && (

                  <div className="obq-method-row">

                    <div className="obq-method-label">
                      <span className="obq-method-dot legacy" />
                      Sin método registrado
                    </div>

                    <strong>
                      {resumen.metodos.SinRegistrar.toLocaleString(
                        "es-CO"
                      )}
                    </strong>

                  </div>

                )}

              </div>

            </div>

          </div>


          {/* =====================================
      TERCERA FILA
  ====================================== */}

          <div
            className={`obq-dashboard-grid obq-dashboard-grid-actividad ${mostrarTodasZonas ? "expandido" : "plegado"
              }`}
          >

            {/* ZONAS */}

            <div className="obq-dashboard-panel">

              <div className="obq-panel-header">
                <div>
                  <h3>Entregas por zona</h3>

                  <span>
                    Avance de entrega por ubicación
                  </span>
                </div>
              </div>

              <div className="obq-zone-list">

                {zonasVisibles.map((zona) => (

                  <div
                    className="obq-zone-row"
                    key={zona.nombre}
                  >

                    <div className="obq-zone-name">

                      <strong>
                        {zona.nombre}
                      </strong>

                      <span>
                        {zona.entregados.toLocaleString("es-CO")}
                        {" / "}
                        {zona.total.toLocaleString("es-CO")}
                      </span>

                    </div>

                    <div className="obq-zone-progress">
                      <div
                        style={{
                          width: `${zona.porcentaje}%`
                        }}
                      />
                    </div>

                    <strong className="obq-zone-percent">
                      {zona.porcentaje}%
                    </strong>

                  </div>

                ))}

              </div>

              {hayMasZonas && (
                <div className="obq-zone-toggle-wrapper">
                  <button
                    type="button"
                    className="obq-zone-toggle"
                    onClick={() =>
                      setMostrarTodasZonas((prev) => !prev)
                    }
                  >
                    {mostrarTodasZonas
                      ? "Mostrar menos"
                      : `Ver todas las zonas (${resumen.zonas.length})`}
                  </button>
                </div>
              )}

            </div>


            {/* ÚLTIMAS ENTREGAS */}

            <div className="obq-dashboard-panel">

              <div className="obq-panel-header">
                <div>
                  <h3>Últimas entregas</h3>

                  <span>
                    Movimientos registrados recientemente
                  </span>
                </div>
              </div>

              <div className="obq-last-deliveries">

                {resumen.ultimasEntregas.length === 0 ? (

                  <div className="obq-empty-dashboard">
                    No hay entregas registradas.
                  </div>

                ) : (

                  resumen.ultimasEntregas.map((entrega) => (

                    <div
                      className="obq-last-delivery"
                      key={entrega._id}
                    >

                      <div className="obq-last-icon">
                        <FiGift size={15} />
                      </div>

                      <div className="obq-last-info">

                        <strong>
                          {entrega.Nombre || "Sin nombre"}
                        </strong>

                        <span>
                          {entrega.Obsequio || "Obsequio"}
                          {" · "}
                          {entrega.ejecutivo ||
                            "Sin responsable"}
                        </span>

                      </div>

                      <div className="obq-last-date">

                        {entrega.fechaEntrega
                          ? new Date(
                            entrega.fechaEntrega
                          ).toLocaleDateString(
                            "es-CO",
                            {
                              day: "2-digit",
                              month: "short"
                            }
                          )
                          : "—"}

                      </div>

                    </div>

                  ))

                )}

              </div>

            </div>

          </div>

        </div>


        {/* ===== FILTROS (idénticos a Inventario) ===== */}
        <div className="inv-filters">
          <div className="inv-row">
            <div className="ben-field">
              <FiSearch className="inv-icon" />

              <input
                placeholder="Buscar por asociado o identificación..."
                value={filtros.busqueda}
                name="busqueda"
                onChange={handleFiltroChange}
              />
            </div>

            <select
              name="ciudad"
              value={filtros.ciudad}
              onChange={handleFiltroChange}
            >
              <option value="">Todas las zonas</option>

              {opcionesCiudad.map((ciudad) => (
                <option key={ciudad} value={ciudad}>
                  {ciudad}
                </option>
              ))}
            </select>

            <select
              name="empresa"
              value={filtros.empresa}
              onChange={handleFiltroChange}
            >
              <option value="">Todas las empresas</option>

              {opcionesEmpresa.map((empresa) => (
                <option key={empresa} value={empresa}>
                  {empresa}
                </option>
              ))}
            </select>

            <select
              name="obsequio"
              value={filtros.obsequio}
              onChange={handleFiltroChange}
            >
              <option value="">Todos los obsequios</option>

              {opcionesObsequio.map((obsequio) => (
                <option key={obsequio} value={obsequio}>
                  {obsequio}
                </option>
              ))}
            </select>

            <select
              name="estado"
              value={filtros.estado}
              onChange={handleFiltroChange}
            >
              <option value="">Todos los estados</option>

              {opcionesEstado.map((estado) => (
                <option key={estado} value={estado}>
                  {estado}
                </option>
              ))}
            </select>

            <select
              name="ejecutivo"
              value={filtros.ejecutivo}
              onChange={handleFiltroChange}
            >
              <option value="">Todos los ejecutivos</option>

              {opcionesEjecutivo.map((ejecutivo) => (
                <option key={ejecutivo} value={ejecutivo}>
                  {ejecutivo}
                </option>
              ))}
            </select>

            <button
              type="button"
              className="inv-btn-reset-filters"
              onClick={restablecerFiltros}
              disabled={!hayFiltrosActivos}
              title="Restablecer filtros"
            >
              <FiRefreshCw size={15} />
              Restablecer
            </button>
          </div>
        </div>

        {/* ======================================
     ⭐ TABLA
      ====================================== */}
        <div className="obq-table-wrapper">
          <table className="obq-table">
            <thead>
              <tr>
                <th>Identificación</th>
                <th>Nombre</th>
                <th>Teléfono</th>
                <th>Zona de Entrega</th>
                <th>Empresa</th>
                <th>Obsequio</th>
                <th>Estado</th>
                <th>Responsable</th>
                <th>Método</th>
                <th>Fecha Entrega</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {currentRecords.map((asociado) => (
                <tr key={asociado.Cedula}>
                  <td>{asociado.Cedula}</td>
                  <td>{asociado.Nombre}</td>
                  <td>{asociado.Telefono}</td>
                  <td>{asociado.Ciudad}</td>
                  <td className="obs-truncate-cell">
                    {asociado.Empresa}
                  </td>
                  <td>{asociado.Obsequio}</td>

                  <td>
                    {asociado.Estado_Entrega === "Entregado" ? (
                      <span className="obs-chip-green">Entregado</span>
                    ) : (
                      <span className="obs-chip-gray">Pendiente</span>
                    )}
                  </td>

                  <td className="obs-truncate-cell">
                    {asociado.ejecutivo || "-"}
                  </td>

                  <td>
                    {asociado.metodoEntrega || "-"}
                  </td>

                  <td>
                    {asociado.fechaEntrega
                      ? new Date(asociado.fechaEntrega).toLocaleDateString()
                      : "-"}
                  </td>

                  <td>
                    <div className="inv-actions-row">

                      <button
                        className="inv-icon-btn"
                        title="Ver detalles"
                        onClick={() => setEntregaSeleccionada(asociado)}
                      >
                        <FiEye size={15} />
                      </button>

                      <button
                        className="inv-icon-btn"
                        title={
                          asociado.Estado_Entrega === "Entregado"
                            ? "Ya fue entregado"
                            : "Registrar entrega"
                        }
                        disabled={
                          asociado.Estado_Entrega === "Entregado"
                        }
                        onClick={() =>
                          abrirModalEntrega(asociado)
                        }
                      >
                        <FiTruck size={15} />
                      </button>

                      <button
                        className="inv-icon-btn"
                        title="Editar teléfono"
                        disabled={asociado.Estado_Entrega === "Entregado"}
                        onClick={() => setEditarAsociado(asociado)}
                      >
                        <FiEdit2 size={15} />
                      </button>

                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Paginación */}
          <div className="obq-paginacion">
            <button
              className="obq-btn-page"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
            >
              Anterior
            </button>

            <span className="obq-pagina-info">
              Página {currentPage} de {totalPaginas}
            </span>

            <button
              className="obq-btn-page"
              disabled={currentPage === totalPaginas}
              onClick={() => setCurrentPage(p => Math.min(p + 1, totalPaginas))}
            >
              Siguiente
            </button>
          </div>
        </div>

        {/* ======================================
       ⭐ MODAL
====================================== */}
        {showModal && (
          <div
            className="obq-modal-overlay"
            onClick={() => setShowModal(false)}
          >
            <div
              className="obq-modal obq-modal-obsequio"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>Crear Nueva Entrega</h3>

              <div className="obq-modal-grid obq-modal-grid-3">

                {[
                  { label: "Cédula", key: "Cedula" },
                  { label: "Nombre", key: "Nombre" },
                  { label: "Teléfono", key: "Telefono" },
                  { label: "Ciudad", key: "Ciudad" },
                  { label: "Empresa", key: "Empresa" }
                ].map((campo) => (
                  <div
                    className="obq-modal-field"
                    key={campo.key}
                  >
                    <label>
                      {campo.label}
                    </label>

                    <input
                      type="text"
                      name={campo.key}
                      value={
                        nuevoRegistro[campo.key] || ""
                      }
                      onChange={(e) =>
                        setNuevoRegistro({
                          ...nuevoRegistro,
                          [campo.key]:
                            e.target.value
                        })
                      }
                    />
                  </div>
                ))}

                <div className="obq-modal-field">
                  <label>Obsequio</label>

                  <select
                    name="Obsequio"
                    value={
                      nuevoRegistro.Obsequio
                    }
                    onChange={(e) =>
                      setNuevoRegistro({
                        ...nuevoRegistro,
                        Obsequio:
                          e.target.value
                      })
                    }
                  >
                    <option value="">
                      Seleccione...
                    </option>

                    {[
                      "Cumpleaños",
                      "Amor y Amistad",
                      "Navidad",
                      "Kit Escolar"
                    ].map((t) => (
                      <option
                        key={t}
                        value={t}
                      >
                        {t}
                      </option>
                    ))}
                  </select>
                </div>

              </div>

              <div className="obq-modal-actions">

                <button
                  className="obq-btn-secondary"
                  onClick={() =>
                    setShowModal(false)
                  }
                >
                  Cancelar
                </button>

                <button
                  className="obq-btn-primary"
                  onClick={handleGuardar}
                >
                  Guardar
                </button>

              </div>

            </div>
          </div>
        )}


        {entregaSeleccionada && (
          <div
            className="obq-modal-overlay"
            onClick={() => setEntregaSeleccionada(null)}
          >
            <div
              className="obq-modal obq-modal-detalle-entrega"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="obq-detalle-header">
                <div>
                  <h3>Detalles de la entrega</h3>

                  <p>
                    Información y trazabilidad del obsequio seleccionado.
                  </p>
                </div>

                <span
                  className={
                    entregaSeleccionada.Estado_Entrega === "Entregado"
                      ? "obq-detalle-estado entregado"
                      : "obq-detalle-estado pendiente"
                  }
                >
                  {entregaSeleccionada.Estado_Entrega || "Pendiente"}
                </span>
              </div>

              <div className="obq-detalle-contenido">
                {/* DATOS DEL ASOCIADO */}
                <section className="obq-detalle-seccion">
                  <div className="obq-detalle-seccion-titulo">
                    <FiUsers size={17} />

                    <div>
                      <h4>Datos del asociado</h4>
                      <span>Persona beneficiaria del obsequio</span>
                    </div>
                  </div>

                  <div className="obq-detalle-grid">
                    <div className="obq-detalle-campo">
                      <label>Identificación</label>
                      <span>{entregaSeleccionada.Cedula || "—"}</span>
                    </div>

                    <div className="obq-detalle-campo">
                      <label>Nombre completo</label>
                      <span>{entregaSeleccionada.Nombre || "—"}</span>
                    </div>

                    <div className="obq-detalle-campo">
                      <label>Celular</label>
                      <span>{entregaSeleccionada.Telefono || "—"}</span>
                    </div>

                    <div className="obq-detalle-campo">
                      <label>Empresa</label>
                      <span>{entregaSeleccionada.Empresa || "—"}</span>
                    </div>

                    <div className="obq-detalle-campo">
                      <label>Zona de entrega</label>
                      <span>{entregaSeleccionada.Ciudad || "—"}</span>
                    </div>
                  </div>
                </section>

                {/* RESPONSABLE DE LA ENTREGA */}
                <section className="obq-detalle-seccion">
                  <div className="obq-detalle-seccion-titulo">
                    <FiSend size={17} />

                    <div>
                      <h4>Responsable de la entrega</h4>
                      <span>Ejecutivo que confirmó el proceso</span>
                    </div>
                  </div>

                  <div className="obq-detalle-grid">
                    <div className="obq-detalle-campo">
                      <label>Nombre del ejecutivo</label>
                      <span>{entregaSeleccionada.ejecutivo || "—"}</span>
                    </div>

                    <div className="obq-detalle-campo">
                      <label>Identificación del ejecutivo</label>
                      <span>{entregaSeleccionada.cedulaEjecutivo || "—"}</span>
                    </div>
                  </div>
                </section>

                {/* DATOS DE LA ENTREGA */}
                <section className="obq-detalle-seccion">
                  <div className="obq-detalle-seccion-titulo">
                    <FiGift size={17} />

                    <div>
                      <h4>Datos de la entrega</h4>
                      <span>Información de confirmación y trazabilidad</span>
                    </div>
                  </div>

                  <div className="obq-detalle-grid">
                    <div className="obq-detalle-campo">
                      <label>Obsequio</label>
                      <span>{entregaSeleccionada.Obsequio || "—"}</span>
                    </div>

                    <div className="obq-detalle-campo">
                      <label>Método de entrega</label>
                      <span>{entregaSeleccionada.metodoEntrega || "—"}</span>
                    </div>

                    <div className="obq-detalle-campo">
                      <label>Código utilizado</label>
                      <span>
                        {entregaSeleccionada.codigoEntrega || "No aplica"}
                      </span>
                    </div>

                    <div className="obq-detalle-campo">
                      <label>Fecha de entrega</label>
                      <span>
                        {entregaSeleccionada.fechaEntrega
                          ? new Date(
                            entregaSeleccionada.fechaEntrega
                          ).toLocaleString("es-CO", {
                            dateStyle: "medium",
                            timeStyle: "short",
                          })
                          : "—"}
                      </span>
                    </div>

                    <div className="obq-detalle-campo obq-detalle-campo-completo">
                      <label>Observaciones</label>

                      <span>
                        {entregaSeleccionada.observacionEntrega ||
                          "No se registraron observaciones para esta entrega."}
                      </span>
                    </div>
                  </div>
                </section>
              </div>

              <div className="obq-modal-actions">
                <button
                  className="obq-btn-primary"
                  onClick={() => setEntregaSeleccionada(null)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        {editarAsociado && (
          <div className="obq-modal-overlay" onClick={() => setEditarAsociado(null)}>
            <div className="obq-modal" onClick={(e) => e.stopPropagation()}>
              <h3>Editar Teléfono</h3>

              <div className="obq-modal-field">
                <label>Nombre</label>
                <input value={editarAsociado.Nombre} disabled />
              </div>

              <div className="obq-modal-field">
                <label>Teléfono</label>
                <input
                  value={editarAsociado.Telefono}
                  onChange={(e) =>
                    setEditarAsociado({
                      ...editarAsociado,
                      Telefono: e.target.value,
                    })
                  }
                />
              </div>

              <div className="obq-modal-actions">
                <button className="obq-btn-secondary" onClick={() => setEditarAsociado(null)}>
                  Cancelar
                </button>

                <button className="obq-btn-primary" onClick={guardarTelefonoEditado}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        )}

        {showEjecutivosModal && (
          <div
            className="obq-modal-overlay"
            onClick={() => setShowEjecutivosModal(false)}
          >
            <div
              className="obq-modal obq-modal-obsequio"
              onClick={(e) => e.stopPropagation()}
              style={{ display: "flex", flexDirection: "column", maxHeight: "85vh" }}
            >
              {/* HEADER (sin X) */}
              <div style={{ paddingBottom: 10 }}>
                <h3 style={{ margin: 0, textAlign: "center" }}>Gestión de Ejecutivos</h3>

                <p
                  style={{
                    margin: "6px 0 0",
                    color: "#666",
                    fontSize: 13,
                    textAlign: "center",
                  }}
                >
                  Crea o elimina ejecutivos autorizados para entregas de obsequios.
                </p>
              </div>

              {/* BODY SCROLLEABLE */}
              <div style={{ overflowY: "auto", paddingRight: 2 }}>

                {/* BUSCADOR */}
                <div style={{ marginTop: 10, display: "flex", justifyContent: "center" }}>
                  <div className="buscador-ejecutivos">
                    <FiSearch className="icono-busqueda" />
                    <input
                      type="text"
                      placeholder="Buscar por cédula o nombre..."
                      value={qEjecutivo}
                      onChange={(e) => setQEjecutivo(e.target.value)}
                    />
                  </div>
                </div>

                {/* LISTA */}
                <div style={{ marginTop: 12 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h4 style={{ margin: 0 }}>Ejecutivos registrados</h4>
                    <span style={{ color: "#666", fontSize: 13 }}>
                      {ejecutivosFiltrados.length} resultado(s)
                    </span>
                  </div>

                  <div
                    style={{
                      marginTop: 10,
                      border: "1px solid #eee",
                      borderRadius: 12,
                      overflow: "hidden",
                    }}
                  >
                    {loadingEjecutivos ? (
                      <div style={{ padding: 14, color: "#666" }}>Cargando ejecutivos…</div>
                    ) : ejecutivosFiltrados.length === 0 ? (
                      <div style={{ padding: 14, color: "#666" }}>
                        No hay ejecutivos (o tu búsqueda no encontró resultados).
                      </div>
                    ) : (
                      ejecutivosPageItems.map((e) => (
                        <div
                          key={e._id}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 10,
                            padding: 12,
                            borderBottom: "1px solid #f2f2f2",
                          }}
                        >
                          <div style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ fontWeight: 700 }}>
                              {e.nombre}{" "}
                              <span style={{ fontWeight: 500, color: "#777" }}>
                                · {e.cedula}
                              </span>
                            </div>

                            <div style={{ fontSize: 13, color: "#666", marginTop: 2 }}>
                              {e.empresa || "—"} · {e.ciudad || "—"} · {e.telefono || "—"}
                            </div>
                          </div>

                          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <span
                              className={
                                String(e.estado).toLowerCase() === "activo"
                                  ? "badge activo"
                                  : "badge inactivo"
                              }
                              style={{ fontSize: 12 }}
                            >
                              {e.estado || "activo"}
                            </span>

                            <button
                              className="inv-icon-btn"
                              title="Eliminar"
                              onClick={() => setConfirmDelete(e)}
                            >
                              <FiTrash2 size={15} />
                            </button>
                          </div>
                        </div>
                      ))
                    )}
                  </div>

                  {/* PAGINACIÓN (5 por página) */}
                  {ejecutivosFiltrados.length > 0 && (
                    <div className="inv-paginacion" style={{ marginTop: 10 }}>
                      <button
                        className="inv-btn-paginacion"
                        disabled={pageEjecutivos === 1}
                        onClick={() => setPageEjecutivos((p) => Math.max(1, p - 1))}
                      >
                        Anterior
                      </button>

                      <span className="inv-pagina-info">
                        Página {pageEjecutivos} de {totalPagesEjecutivos}
                      </span>

                      <button
                        className="inv-btn-paginacion"
                        disabled={pageEjecutivos === totalPagesEjecutivos}
                        onClick={() =>
                          setPageEjecutivos((p) =>
                            Math.min(totalPagesEjecutivos, p + 1)
                          )
                        }
                      >
                        Siguiente
                      </button>
                    </div>
                  )}
                </div>

                {/* PANEL NUEVO EJECUTIVO (debajo de la lista) */}
                {showCrearEjecutivo && (
                  <div
                    style={{
                      marginTop: 14,
                      padding: 12,
                      border: "1px solid #eee",
                      borderRadius: 12,
                    }}
                  >
                    <h4 style={{ margin: 0 }}>Nuevo ejecutivo</h4>

                    <div className="obq-modal-grid obq-modal-grid-3" style={{ marginTop: 10 }}>
                      <div className="obq-modal-field">
                        <label>Cédula *</label>
                        <input
                          value={nuevoEjecutivo.cedula}
                          onChange={(e) =>
                            setNuevoEjecutivo({ ...nuevoEjecutivo, cedula: e.target.value })
                          }
                        />
                      </div>

                      <div className="obq-modal-field">
                        <label>Nombre *</label>
                        <input
                          value={nuevoEjecutivo.nombre}
                          onChange={(e) =>
                            setNuevoEjecutivo({ ...nuevoEjecutivo, nombre: e.target.value })
                          }
                        />
                      </div>

                      <div className="obq-modal-field">
                        <label>Teléfono</label>
                        <input
                          value={nuevoEjecutivo.telefono}
                          onChange={(e) =>
                            setNuevoEjecutivo({ ...nuevoEjecutivo, telefono: e.target.value })
                          }
                        />
                      </div>

                      <div className="obq-modal-field">
                        <label>Empresa</label>
                        <input
                          value={nuevoEjecutivo.empresa}
                          onChange={(e) =>
                            setNuevoEjecutivo({ ...nuevoEjecutivo, empresa: e.target.value })
                          }
                        />
                      </div>

                      <div className="obq-modal-field">
                        <label>Ciudad</label>
                        <input
                          value={nuevoEjecutivo.ciudad}
                          onChange={(e) =>
                            setNuevoEjecutivo({ ...nuevoEjecutivo, ciudad: e.target.value })
                          }
                        />
                      </div>

                      <div className="obq-modal-field">
                        <label>Estado</label>
                        <select
                          value={nuevoEjecutivo.estado}
                          onChange={(e) =>
                            setNuevoEjecutivo({ ...nuevoEjecutivo, estado: e.target.value })
                          }
                        >
                          <option value="activo">activo</option>
                          <option value="inactivo">inactivo</option>
                        </select>
                      </div>
                    </div>

                    {/* BOTONES DEL PANEL (crear dentro del panel) */}
                    <div className="obq-modal-actions" style={{ marginTop: 10 }}>
                      <button
                        className="obq-btn-secondary"
                        onClick={() => setShowCrearEjecutivo(false)}
                      >
                        Cancelar
                      </button>

                      <button className="obq-btn-primary" onClick={crearEjecutivo}>
                        Autorizar
                      </button>
                    </div>
                  </div>
                )}

                {/* CONFIRM DELETE */}
                {confirmDelete && (
                  <div
                    style={{
                      marginTop: 12,
                      padding: 12,
                      border: "1px solid #ffe2e2",
                      borderRadius: 12,
                    }}
                  >
                    <div style={{ fontWeight: 700 }}>¿Eliminar ejecutivo?</div>
                    <div style={{ marginTop: 4, color: "#666", fontSize: 13 }}>
                      Vas a eliminar a <strong>{confirmDelete.nombre}</strong> ({confirmDelete.cedula}).
                    </div>

                    <div className="obq-modal-actions" style={{ marginTop: 10 }}>
                      <button
                        className="obq-btn-secondary"
                        onClick={() => setConfirmDelete(null)}
                      >
                        Cancelar
                      </button>

                      <button
                        className="obq-btn-primary"
                        onClick={async () => {
                          await eliminarEjecutivo(confirmDelete._id);
                          setConfirmDelete(null);
                        }}
                      >
                        Eliminar
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* FOOTER (solo Cerrar + Nuevo juntos) */}
              <div
                style={{
                  marginTop: 12,
                  paddingTop: 12,
                  borderTop: "1px solid #eee",
                  display: "flex",
                  justifyContent: "center",
                  gap: 10,
                }}
              >
                <button
                  className="obq-btn-secondary"
                  onClick={() => setShowEjecutivosModal(false)}
                >
                  Cerrar
                </button>

                <button
                  className="obq-btn-primary"
                  onClick={() => {
                    setConfirmDelete(null);
                    setShowCrearEjecutivo((v) => !v);
                  }}
                >
                  Agregar nuevo
                </button>
              </div>
            </div>
          </div>
        )}

        {showImportModal && (
          <div className="obq-modal-overlay" onClick={cerrarImportModalObsequios}>
            <div className="obq-modal obq-modal-obsequio" onClick={(e) => e.stopPropagation()}>
              <h3>Importación Base de Obsequios</h3>

              <p style={{ marginTop: 6, opacity: 0.85 }}>
                Vista previa ({importRows.length} registros)
              </p>

              <div style={{ maxHeight: 320, overflow: "auto", marginTop: 10 }}>
                <table className="obq-table" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      {Object.keys(importRows[0] || {}).slice(0, 9).map((k) => (
                        <th key={k}>{k}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {importRows.slice(0, 8).map((r, i) => (
                      <tr key={i}>
                        {Object.keys(importRows[0] || {}).slice(0, 9).map((k) => (
                          <td key={k}>{String(r[k] ?? "")}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="obq-modal-actions" style={{ marginTop: 14 }}>
                <button className="obq-btn-secondary" onClick={cerrarImportModalObsequios}>
                  Cancelar
                </button>

                <button
                  className="obq-btn-primary"
                  onClick={confirmarImportacionObsequios}
                  disabled={importLoading || importRows.length === 0}
                >
                  {importLoading ? "Importando..." : "Confirmar importación"}
                </button>
              </div>
            </div>
          </div>
        )}

        {modalEntrega && asociadoParaEntregar && (
          <div
            className="obq-modal-overlay"
            onClick={cerrarModalEntrega}
          >
            <div
              className="obq-modal obq-modal-proceso-entrega"
              onClick={(e) => e.stopPropagation()}
            >
              {/* ENCABEZADO */}
              <div className="obq-entrega-header">
                <h3>Registrar Entrega</h3>

                <p>
                  Define cómo se realizará la entrega y selecciona al
                  ejecutivo responsable.
                </p>
              </div>

              {/* DATOS DEL ASOCIADO */}
              <div className="obq-entrega-asociado">
                <div>
                  <span>Asociado</span>

                  <strong>
                    {asociadoParaEntregar.Nombre}
                  </strong>
                </div>

                <div>
                  <span>Obsequio</span>

                  <strong>
                    {asociadoParaEntregar.Obsequio}
                  </strong>
                </div>
              </div>

              {/* MÉTODO DE ENTREGA */}
              <section className="obq-entrega-section">
                <div className="obq-entrega-section-title">
                  <strong>Método de entrega</strong>

                  <span>
                    Selecciona cómo será confirmada esta entrega.
                  </span>
                </div>

                <div className="obq-metodos-entrega">
                  <button
                    type="button"
                    className={`obq-metodo-card ${metodoEntregaSeleccionado === "Interna"
                      ? "active"
                      : ""
                      }`}
                    onClick={() => {
                      setMetodoEntregaSeleccionado("Interna");
                      setCodigoEntregaWhatsapp(null);
                      setCodigoEntregaIngresado("");
                      setTimerEntrega(0);
                    }}
                  >
                    <div className="obq-metodo-icon">
                      <FiUsers size={19} />
                    </div>

                    <div>
                      <strong>Entrega Interna</strong>

                      <span>
                        Registro directo sin validación digital.
                      </span>
                    </div>
                  </button>

                  <button
                    type="button"
                    className={`obq-metodo-card ${metodoEntregaSeleccionado === "WhatsApp"
                      ? "active"
                      : ""
                      }`}
                    onClick={() => {
                      setMetodoEntregaSeleccionado("WhatsApp");
                      setCodigoEntregaWhatsapp(null);
                      setCodigoEntregaIngresado("");
                      setTimerEntrega(0);
                    }}
                  >
                    <div className="obq-metodo-icon">
                      <FiSend size={19} />
                    </div>

                    <div>
                      <strong>Validación de Identidad</strong>

                      <span>
                        Confirmación mediante código enviado al asociado.
                      </span>
                    </div>
                  </button>
                </div>
              </section>

              {/* RESPONSABLE DE LA ENTREGA */}
              {metodoEntregaSeleccionado && (
                <section className="obq-entrega-section">
                  <div className="obq-entrega-section-title">
                    <strong>Responsable de la entrega</strong>

                    <span>
                      Selecciona un ejecutivo autorizado.
                    </span>
                  </div>

                  <div className="obq-entrega-search">
                    <FiSearch size={15} />

                    <input
                      type="text"
                      placeholder="Buscar por nombre, identificación o empresa..."
                      value={busquedaEjecutivoEntrega}
                      onChange={(e) =>
                        setBusquedaEjecutivoEntrega(e.target.value)
                      }
                    />
                  </div>

                  <div className="obq-ejecutivos-entrega-list">
                    {loadingEjecutivos ? (
                      <div className="obq-entrega-empty">
                        Cargando ejecutivos...
                      </div>
                    ) : ejecutivosDisponibles.length === 0 ? (
                      <div className="obq-entrega-empty">
                        No se encontraron ejecutivos.
                      </div>
                    ) : (
                      ejecutivosDisponibles.map((ejecutivo) => {
                        const seleccionado =
                          ejecutivoSeleccionado?._id === ejecutivo._id;

                        return (
                          <button
                            type="button"
                            key={ejecutivo._id}
                            className={`obq-ejecutivo-entrega ${seleccionado ? "selected" : ""
                              }`}
                            onClick={() => {
                              setEjecutivoSeleccionado(ejecutivo);
                              setCodigoEntregaWhatsapp(null);
                              setCodigoEntregaIngresado("");
                            }}
                          >
                            <div className="obq-ejecutivo-avatar">
                              <FiUserCheck size={16} />
                            </div>

                            <div className="obq-ejecutivo-data">
                              <strong>
                                {ejecutivo.nombre}
                              </strong>

                              <span>
                                {ejecutivo.cedula}

                                {ejecutivo.empresa
                                  ? ` · ${ejecutivo.empresa}`
                                  : ""}
                              </span>
                            </div>

                            <div
                              className={`obq-selection-circle ${seleccionado ? "active" : ""
                                }`}
                            >
                              {seleccionado && "✓"}
                            </div>
                          </button>
                        );
                      })
                    )}
                  </div>
                </section>
              )}

              {/* CONFIRMACIÓN DE ENTREGA INTERNA */}
              {metodoEntregaSeleccionado === "Interna" &&
                ejecutivoSeleccionado && (
                  <section className="obq-entrega-confirm-box">
                    <div>
                      <strong>Entrega Interna</strong>

                      <span>
                        La entrega quedará registrada a nombre de{" "}
                        {ejecutivoSeleccionado.nombre}.
                      </span>
                    </div>

                    <button
                      type="button"
                      className="obq-btn-primary"
                      disabled={registrandoEntrega}
                      onClick={confirmarEntregaInterna}
                    >
                      {registrandoEntrega
                        ? "Registrando..."
                        : "Confirmar entrega"}
                    </button>
                  </section>
                )}

              {/* VALIDACIÓN POR WHATSAPP */}
              {metodoEntregaSeleccionado === "WhatsApp" &&
                ejecutivoSeleccionado && (
                  <section className="obq-entrega-whatsapp">
                    {!codigoEntregaWhatsapp ? (
                      <div className="obq-entrega-confirm-box">
                        <div>
                          <strong>Validación de Identidad</strong>

                          <span>
                            Se enviará un código por WhatsApp al número registrado
                            del asociado.
                          </span>
                        </div>

                        <button
                          type="button"
                          className="obq-btn-primary"
                          onClick={enviarCodigoEntregaWhatsapp}
                          disabled={
                            enviandoCodigoEntrega ||
                            timerEntrega > 0
                          }
                        >
                          {enviandoCodigoEntrega
                            ? "Enviando..."
                            : "Enviar código"}
                        </button>
                      </div>
                    ) : (
                      <div className="obq-entrega-otp">
                        <div className="obq-entrega-otp-header">
                          <strong> Código enviado</strong>

                          <span>
                            Ingresa los seis dígitos recibidos por WhatsApp.
                          </span>
                        </div>

                        <div className="obq-codigo-otp">
                          {[0, 1, 2, 3, 4, 5].map((index) => (
                            <input
                              key={index}
                              id={`obq-entrega-otp-${index}`}
                              type="text"
                              inputMode="numeric"
                              autoComplete="one-time-code"
                              maxLength={1}
                              value={
                                codigoEntregaIngresado[index] || ""
                              }
                              disabled={
                                verificandoCodigoEntrega ||
                                registrandoEntrega
                              }
                              onChange={(e) => {
                                const value = e.target.value
                                  .replace(/\D/g, "")
                                  .slice(-1);

                                const caracteres =
                                  codigoEntregaIngresado
                                    .padEnd(6, " ")
                                    .split("");

                                caracteres[index] = value || " ";

                                const nuevoCodigo = caracteres
                                  .join("")
                                  .trimEnd();

                                setCodigoEntregaIngresado(
                                  nuevoCodigo
                                );

                                if (value && index < 5) {
                                  document
                                    .getElementById(
                                      `obq-entrega-otp-${index + 1}`
                                    )
                                    ?.focus();
                                }

                                if (
                                  value &&
                                  index === 5 &&
                                  nuevoCodigo.length === 6
                                ) {
                                  verificarCodigoEntregaWhatsapp(
                                    nuevoCodigo
                                  );
                                }
                              }}
                              onKeyDown={(e) => {
                                if (
                                  e.key === "Backspace" &&
                                  !codigoEntregaIngresado[index] &&
                                  index > 0
                                ) {
                                  document
                                    .getElementById(
                                      `obq-entrega-otp-${index - 1}`
                                    )
                                    ?.focus();
                                }
                              }}
                              onPaste={(e) => {
                                e.preventDefault();

                                const codigoPegado =
                                  e.clipboardData
                                    .getData("text")
                                    .replace(/\D/g, "")
                                    .slice(0, 6);

                                setCodigoEntregaIngresado(
                                  codigoPegado
                                );

                                if (codigoPegado.length === 6) {
                                  verificarCodigoEntregaWhatsapp(
                                    codigoPegado
                                  );
                                }
                              }}
                            />
                          ))}
                        </div>

                        <div className="obq-entrega-otp-footer">
                          <span>
                            {verificandoCodigoEntrega
                              ? "Validando código..."
                              : `${codigoEntregaIngresado.length}/6 dígitos`}
                          </span>

                          <button
                            type="button"
                            className="obq-reenviar-btn"
                            disabled={
                              timerEntrega > 0 ||
                              enviandoCodigoEntrega
                            }
                            onClick={enviarCodigoEntregaWhatsapp}
                          >
                            {timerEntrega > 0
                              ? `Reenviar en ${String(
                                Math.floor(timerEntrega / 60)
                              ).padStart(2, "0")}:${String(
                                timerEntrega % 60
                              ).padStart(2, "0")}`
                              : "Reenviar código"}
                          </button>
                        </div>

                        <button
                          type="button"
                          className="obq-btn-primary obq-validar-referencia-btn"
                          disabled={
                            codigoEntregaIngresado.length !== 6 ||
                            verificandoCodigoEntrega ||
                            registrandoEntrega
                          }
                          onClick={() =>
                            verificarCodigoEntregaWhatsapp(
                              codigoEntregaIngresado
                            )
                          }
                        >
                          {verificandoCodigoEntrega ||
                            registrandoEntrega
                            ? "Validando..."
                            : "Confirmar código"}
                        </button>
                      </div>
                    )}
                  </section>
                )}

              {/* PIE DEL MODAL */}
              <div className="obq-entrega-footer">
                <button
                  type="button"
                  className="obq-btn-secondary"
                  onClick={cerrarModalEntrega}
                  disabled={registrandoEntrega}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}

      </div>

    </>

  );
}

export default Obsequios;
